// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3o7XL","title":"Images90_title__3yNVQ","images":"Images90_images__Scjkq"};